module.exports = __webpack_public_path__ + "static/mccarthy-hall-3-95eaa1920fa655d87d7ea535938e5e96.jpg";